import {BasicEntity} from '../../framework/message/BasicEntity';
import {Country} from '../../locale/message/Country';
import {Currency} from '../../locale/message/Currency';
import {Language} from '../../locale/message/Language';
import {TranslatedEmb} from '../../locale/message/TranslatedEmb';

export class BusinessUnit extends BasicEntity {
color: string;
countries: {[key: string]: Country};
currencies: {[key: string]: Currency};
deactivated: boolean | null;
defaultCountryCode: string;
defaultCurrencyCode: string;
defaultLanguageCode: string;
description: TranslatedEmb;
endDate: number | null;
helpURL: string;
icon: string;
languages: {[key: string]: Language};
mail: string;
mainContactLogin: string;
minRevNumber: number | null;
name: string;
parentCode: string;
siret: string;
startDate: number | null;
status: string;
supportMail: string;
themeCode: string;
}

